import {useStaticQuery, graphql} from 'gatsby';
import {formatDate} from '../utils/date-utils';

const DataCurrencyFootnoteExcavation = () => {
  const data = useStaticQuery(graphql`
    {
      postgres {
        scDataCurrency(dataset: "excavation") {
          currencyDate
        }
      }
    }
  `);
  return <>PHMSA Work Management System as of {formatDate(data.postgres.scDataCurrency.currencyDate)}.</>;
};

export default DataCurrencyFootnoteExcavation;
